import { render } from "./desktop.vue?vue&type=template&id=4b21a839&ts=true"
import script from "./desktop.vue?vue&type=script&lang=ts"
export * from "./desktop.vue?vue&type=script&lang=ts"

import "./desktop.vue?vue&type=style&index=0&id=4b21a839&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__